module.exports = __webpack_public_path__ + "img/cvv-light.d6a208bf.svg";